import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import {
  setThemeImageUrlSend,
  setThemeHighlightTitleColor,
  setThemeImageUrl,
  setThemePopup,
} from "../../../Redux/Actions/VideoHighlightAction";
import styles from "./video-highlight.module.css";
const ThemeDrawer = ({ isOpen, onClose, setDrawerOpen }) => {
  const dispatch = useDispatch();
  const themes = [
    {
      name: "Zone Red",
      showImageUrl: "themes/theme1_show.png",
      imageUrl: "themes/theme1_apply.png",
      themeHighlightTitleColor: "red",
    },
    {
      name: "Zone Blue",
      showImageUrl: "themes/theme2_show.png",
      imageUrl: "themes/theme2_apply.png",
      themeHighlightTitleColor: "blue",
    },
    {
      name: "Zone Yellow",
      showImageUrl: "themes/theme3_show.png",
      imageUrl: "themes/theme3_apply.png",
      themeHighlightTitleColor: "yellow",
    },
    {
      name: "Zone Black",
      showImageUrl: "themes/theme4_show.png",
      imageUrl: "themes/theme4_apply.png",
      themeHighlightTitleColor: "black",
    },
  ];
  const handleThemeSelection = (showImageUrl, themeHighlightTitleColor) => {
    setThemeImageUrlSend(dispatch, "");
    setThemePopup(dispatch, true);
    setDrawerOpen(false);
    setThemeImageUrl(dispatch, showImageUrl);
    setThemeHighlightTitleColor(dispatch, themeHighlightTitleColor);
  };
  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={onClose}
      sx={{ position: "absolute" }}
    >
      <List sx={{ border: "2px solid #7e7e7e" }}>
        <Typography sx={{ textAlign: "center" }}>Highlight Themes</Typography>
        {themes.map((theme, index) => (
          <ListItem key={index}>
            <ListItemAvatar>
              <div
                style={{ margin: "7px" }}
                onClick={() =>
                  handleThemeSelection(
                    theme.showImageUrl,
                    theme.themeHighlightTitleColor
                  )
                }
              >
                <img
                  alt={theme.name}
                  src={theme.showImageUrl}
                  className={`${styles.themeDrawerImage} ${styles.themeHoverImage}`}
                />
                <div className={`${styles.themeDrawerAvatar}`}>
                  <Avatar
                    alt={theme.name}
                    src={theme.showImageUrl}
                    sx={{ width: 24, height: 24 }}
                  />
                  <ListItemText
                    primary={
                      <Typography style={{ fontSize: "16px", color: "black" }}>
                        {theme.name}
                      </Typography>
                    }
                  />
                </div>
              </div>
            </ListItemAvatar>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default ThemeDrawer;
